import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';





const NEET_SectionModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const [subjects, setSubjects] = useState([]);

    let initialData = {
        Section: '',
        Subject: 'Select Subject',
        SubjectID: 0,
        Sn: 0,

    }


    const [examBodyData, setExamBodyData] = useState(initialData);


    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            if (item.Sn > 0) {
                setExamBodyData(item)
            }
            setModalBox(true);

        }
    }));

    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/neet/subjects').then((response) => {
            response.data.subjects.pop();
            setSubjects(response.data.subjects);
        }).catch((error) => {
            console.error('Error fetching subjects:', error);
            toast.error('Failed to fetch subjects');
        }
        );
    }, []);

    const hanldeSaveExamBody = async () => {
        try {
            if (examBodyData.Subject.trim().length === 0 || examBodyData.Subject === 'Select Subject') {
                toast.error("Please select Subject")
                return;
            }
            const response = await axios.post(BACKEND_SERVER_URL + `${!examBodyData.Sn ? '/neet/createSection' : `/neet/updateSection`}`, examBodyData);
            toast.success(response.data.message);
        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message)
        } finally {
            props.setSubjectLoading(!props.loadSubjects);
            setExamBodyData(initialData)
            setModalBox(false);
            setExamBodyData(initialData);
        }

    }
    console.log(subjects);
    return (
        <>
            <Modal onHide={setModalBox} show={modalBox} size="md" backdrop="static"
                keyboard={false} >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel"> {examBodyData.Sn ? "Update Class" : "Upload Class"}</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label htmlFor="sessioncount" className="form-label text-primary">Subject<span className="required">*</span></label>
                            <Select
                                value={{ value: examBodyData.Subject, label: examBodyData.Subject }}
                                onChange={(selectedOption) => {
                                    setExamBodyData({ ...examBodyData, Subject: selectedOption.value.Subject, SubjectID: selectedOption.value.Sn })
                                }}
                                options={subjects?.map((course) => ({ value: course, label: course.Subject }))}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        backgroundColor: 'transparent', // Adjust as needed
                                        borderColor: '#17a2b8', // Adjust as needed

                                    }),
                                }}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="subjects" className="form-label text-primary">Section Name<span className="required">*</span></label>
                            <Select
                                value={{ value: examBodyData.Section, label: examBodyData.Section || 'Select Section' }}
                                onChange={(selectedOption) => {
                                    setExamBodyData({ ...examBodyData, Section: selectedOption.value })
                                }}
                                options={[
                                    { value: 'Class-11', label: 'Class-11' },
                                    { value: 'Class-12', label: 'Class-12' },
                                ]}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        backgroundColor: 'transparent',
                                        borderColor: '#17a2b8',
                                    }),
                                }}
                            />
                        </div>



                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                        <button type="button" className="btn btn-primary btn-xs " onClick={hanldeSaveExamBody}>{examBodyData.Sn ? "Update" : "Upload "}</button>
                    </div>
                </div>
            </Modal>

        </>
    )
})
export default NEET_SectionModal;